import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

// API
import * as API  from '../../../utils/api'

// Actions
import {
  updateForm
} from '../../../actions/onboarding'

import {
  signUpViaMaintainerInvite,
  logIn,
  logOut
} from '../../../actions/user'

import {
  showModal,
} from '../../../actions/modal'

// Components
import FlashMessage from '../../../components/Global/FlashMessage'
import AppCanvasLoader from '../../../components/Global/AppCanvasLoader'
import SignUpForm from './_modules/SignUpForm'

class AcceptInvitationSignUpForm extends Component {

  state = {
    flashMessage: {
      type: '',
      message: ''
    },
    sender: {},
    profile: {},
    formIsValid: false,
    isLoading: true,
    displayForm: false,
    status: '',
    displayErrorMessages: false,
  }

  componentDidMount() {
    const { token } = this.props

    // In case another user session is active, log them out
    this.props.logOutUser()

    API.getInvitationInfo(token)
    .then(response => {
      if (response.error) {
        this.setState({
          isLoading: false
        }, this.setFlashMessage('error', `Error: ${response.error}. Please try again`))
      } else {
        this.initializeForm(response)
      }
    })
  }

  initializeForm(data) {
    const { profile, recipient_email, sender } = data

    this.setState({
      email: recipient_email,
      sender,
      profile,
      isLoading: false,
      displayForm: true
    })
  }

  handleSubmit = (data) => {
    this.setState({
      status: 'submitting'
    }, () => this.signUpAndLogInUser(data))
  }

  signUpAndLogInUser({ dataForSubmit, isAthlete }) {
    this.props.signUpViaMaintainerInvite(dataForSubmit, this.props.token)
    .then(response => {
      if (response.success) {
        const userForLogin = {
          email: isAthlete ? dataForSubmit.athlete_email : dataForSubmit.parent_email,
          password: dataForSubmit.password
        }

        this.props.logInUser(userForLogin)
        .then(() => {
          const { profile } = this.state

          this.props.updateOnboardingForm({
            maintained_profile: profile
          }).then(() => {
            this.props.handleFormSubmit(`/${profile.username}`)
          })
        })
      } else {
        this.setFlashMessage('error', response.message)
      }
    })
  }

  renderFormHeader() {
    const {
      first_name,
      last_name
    } = this.state.profile

    const {
      displayForm
    } = this.state

    return (
      <header>
        <h2>Sign Up for Locker Linked</h2>
        { displayForm &&
          <p>You've been invited to administer {first_name ? ' ' + first_name : ''}{last_name ? ' ' + last_name : ''}'s profile.</p>
        }
      </header>
    )
  }

  setFlashMessage(type, message) {
    this.setState({
      flashMessage: {
        type,
        message
      }
    })
  }

  renderFlashMessage() {
    const { flashMessage } = this.state

    if (flashMessage.message === 'Email already used') {
      return (
        <FlashMessage optionalClasses='error'>
          <p>
            The email you entered has already been used.
          </p>
          <p>
            <Link to="/log-in" className="text-link">Try logging in</Link> or <Link to="/" className="text-link">reset your password</Link>
          </p>
        </FlashMessage>
      )
    } else {
      return flashMessage.message.length > 0
      ? (
        <FlashMessage optionalClasses={flashMessage.type}>
          {flashMessage.message}
        </FlashMessage>
      )
      : ''
    }
  }

  render() {
    const {
      isLoading,
      status,
      displayForm,
      sender,
      email,
    } = this.state

    const {
      isLoggedIn
    } = this.props.user

    return isLoading || isLoggedIn
    ? (<AppCanvasLoader />)
    : (
      <div>
        {this.renderFormHeader()}
        {this.renderFlashMessage()}
        { displayForm &&
          <SignUpForm
            userEmailDisabled
            userEmail={email}
            onSubmit={this.handleSubmit}
            secondaryUserData={sender}
            secondaryUserDataDisabled
            submitting={status === 'submitting'}
          />
        }
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    onboarding: state.onboarding
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    logInUser: (user) => dispatch(logIn(user)),
    logOutUser: () => dispatch(logOut()),
    signUpViaMaintainerInvite: (user, token) => dispatch(signUpViaMaintainerInvite(user, token)),
    updateOnboardingForm: formData => dispatch(updateForm(formData)),
    showModal: modalType => { dispatch(showModal(modalType)) },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AcceptInvitationSignUpForm)



// WEBPACK FOOTER //
// ./src/screens/Onboarding/Forms/AcceptInvitationSignUpForm.js